const SELECTED_ZIPS_STYLE = {
  color: 'rgba(251,153,85,0.2)',
  outline: {
    color: 'rgba(251,153,85, 1)',
    size: 2,
  },
};

const HOVERED_SELECTED_ZIPS_STYLE = {
  color: 'rgba(251,153,85,0.2)',
  outline: {
    color: 'rgba(149, 126, 254, 1)',
    size: 2,
  },
};

export const ZIPS_STYLE = {
  color: 'rgba(149, 126, 254, 0.0)',
  outline: {
    color: 'rgba(149, 126, 254, 0.3)',
    size: 2,
  },
  selected: SELECTED_ZIPS_STYLE,
};

export const HOVERED_ZIPS_STYLE = {
  color: 'rgba(149, 126, 254, 0.0)',
  outline: {
    color: 'rgba(149, 126, 254, 1)',
    size: 2,
  },
  selected: HOVERED_SELECTED_ZIPS_STYLE,
};

export const MARKETS_STYLE = {
  color: 'rgba(149, 126, 254, 0.2)',
  outline: {
    color: 'rgba(149, 126, 254, 1.0)',
    size: 2,
  },
};

export const HOVERED_MARKETS_STYLE = {
  color: 'rgba(149, 126, 254, 0.6)',
  outline: {
    color: 'rgba(149, 126, 254, 1.0)',
    size: 2,
  },
};

// The class in created at the run time because it requires Leaflet library to be loaded (it expends "L.Class.")
// Params:
// * url
// * layerId (layer name in MVTs)
// * idAttr - name of ID attribute
// * style
// * styleHovered
export function getLeafletZipsLayerClass(params) {
  const ZipsLayerClass = window.L.Class.extend({
    initialize: function (options) {
      let that = this;

      this._hoveredFeature = null;

      this._mvtSource = new window.L.TileLayer.MVTSource({
        url: params.url,
        clickableLayers: [params.layerId],
        getIDForLayerFeature: function (feature) {
          return feature.properties[params.idAttr];
        },
        style: function (feature) {
          if (that._hoveredFeature && that._hoveredFeature.id === feature.id) {
            return params.styleHovered;
          } else {
            return params.style;
          }
        },

        //this iterator is just uptimized way (without new array creation) of array sorting
        //sorting rule is the following: first unhovered and unselected features,
        //then selected features and then hovered feature
        featureIteratorFactory: function (features) {
          let state = 'main'; //main, selected, hovered, done
          let selectedFeatures = [];
          let idx = 0;
          return function next() {
            switch (state) {
              case 'main':
                if (idx === features.length) {
                  state = 'selected';
                  idx = 0;
                  return next();
                }
                if (features[idx] === that._hoveredFeature) {
                  idx++;
                  return next();
                }
                if (features[idx].selected) {
                  selectedFeatures.push(features[idx++]);
                  return next();
                }

                return features[idx++];
              case 'selected':
                if (idx === selectedFeatures.length) {
                  state = 'done';
                  for (let i = 0; i < features.length; i++) {
                    if (features[i] === that._hoveredFeature) {
                      return that._hoveredFeature;
                    }
                  }
                } else {
                  return selectedFeatures[idx++];
                }
            }
          };
        },
        ...options,
      });
    },

    updateSelectedFeatures: function (selectedFeatures) {
      let layer = this._mvtSource.layers[params.layerId];
      if (!layer) {
        return;
      }
      for (let idx in layer.features) {
        let f = layer.features[idx];
        if (f.selected && !selectedFeatures[idx]) {
          f.deselect();
        } else if (!f.selected && selectedFeatures[idx]) {
          f.select();
        }
      }
    },

    forEachFeature(callback) {
      let layer = this._mvtSource.layers[params.layerId];
      if (!layer) {
        return;
      }
      for (let idx in layer.features) {
        callback(layer.features[idx]);
      }
    },

    setHoveredFeature: function (id) {
      let layer = this._mvtSource.layers[params.layerId];

      if (!layer) {
        return;
      }

      let f = id ? layer.features[id] : null;
      let prevFeature = this._hoveredFeature;

      this._hoveredFeature = f;

      if (prevFeature && (!f || prevFeature.id !== f.id)) {
        prevFeature.redraw(params.style);
      }

      if (f && (!prevFeature || prevFeature.id !== f.id)) {
        f.redraw(params.styleHovered);
      }
    },

    onAdd: function (map) {
      map.addLayer(this._mvtSource);
    },

    onRemove: function (map) {
      map.removeLayer(this._mvtSource);
    },

    updateOptions: function (options) {
      window.L.Util.setOptions(this._mvtSource, options);
    },

    setFilter: function (filter) {
      this._mvtSource.setFilter(filter);
      setTimeout(() => {
        this._mvtSource.redraw();
      }, 0);
    },
  });

  return ZipsLayerClass;
}
